import { m } from 'framer-motion';

import { Box, Button, Container, Typography } from '@mui/material';

import { varFade, MotionViewport } from '../../components/animate';

export default function AboutMe() {
  return (
    <Container component={MotionViewport} sx={{ mt: 5 }}>
      <Box sx={{ mb: 5 }}>
        <m.div variants={varFade().inUp}>
          <Typography variant="h5" sx={{ textAlign: 'center', maxWidth: 800, mx: 'auto', mb: 2 }}>
            The Leaders Who Inspire Me
          </Typography>
        </m.div>
        <Typography variant="body1" sx={{ textAlign: 'justify', mx: 'auto', mb: 2 }}>
          I’ve always been inspired by leaders who combine vision with compassion. One figure who
          stands out to me is <strong>Mr. Ratan Tata</strong>. His leadership goes beyond business
          success—he has consistently used innovation to drive positive social change. His work with
          the Tata Group, especially in improving education and healthcare, taught me that true
          success isn&apos;t measured by profits alone but by the impact we leave on society. His
          famous words, “I don’t believe in taking the right decisions. I take decisions and then
          make them right,” inspire me to approach challenges with courage, resilience, and
          integrity.
        </Typography>
      </Box>
      <Box sx={{ mb: 5 }}>
        <m.div variants={varFade().inUp}>
          <Typography variant="h5" sx={{ textAlign: 'center', maxWidth: 800, mx: 'auto', mb: 2 }}>
            My Journey to Software Engineering
          </Typography>
        </m.div>
        <Typography variant="body1" sx={{ textAlign: 'justify', mx: 'auto', mb: 2 }}>
          Growing up in a small town with limited resources, I learned early on that opportunities
          may be scarce, but determination can create new paths. My fascination with technology
          began during childhood, when I would spend hours disassembling old electronics to
          understand how they worked. This curiosity led me to the world of coding, and by the age
          of 14, I was already building simple websites and exploring software development. Without
          access to a formal tech education, I turned to online resources and self-learning.
          Late-night coding sessions became a routine, and every setback—whether it was a broken
          piece of code or a missed opportunity—only fueled my determination to improve. Over time,
          my skills grew, and what began as a hobby transformed into a professional calling.
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'justify', mx: 'auto' }}>
          Today, as a software engineer, I bring that same passion and persistence to building
          solutions that address real-world problems. My journey is a testament to the belief that
          no matter where you start, hard work and perseverance can turn dreams into reality. I am
          committed to using technology to make a positive impact, and I continue to embrace every
          challenge as an opportunity to grow and innovate.
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'center', mt: 5 }}>
        <m.div variants={varFade().inUp}>
          <Button variant="contained" color="primary">
            View Projects
          </Button>
        </m.div>
      </Box>
    </Container>
  );
}
